<template>
  <div class="member_v2_wrap bg_banner" :style="bgStyle" :class="bgClass">
    <!--  banner 间距控制 -->
    <memberBanner />
    <!-- 会员卡片 已开通展示 -->
    <template v-if="!isNewUserStatus">
      <!-- 精简版 -->
      <memberCardV2 v-if="isEasyInfoTest" :headInfo="headInfo" :membership="membership" />
      <!-- 常规版 -->
      <memberCard v-else :headInfo="headInfo" :membership="membership" />
    </template>
    <!-- 会员长周期升级入口-->
    <upgradeLongTerm
      v-show="isShowUpgradeLongTerm"
      :membership="membership"
      @onUpgradeSuccess="handleSuccessUpgradeDialog"
    />
    <!-- 会员长周期权益信息条 -->
    <longTermBar
      v-if="isShowLongTerm"
      :class="{ v2_test_margin: isEasyInfoTest }"
      :membership="membership"
    />
    <!-- 暂停信息条-->
    <pauseStatusBar
      v-if="isPauseStatus"
      :class="{ v2_test_margin: isEasyInfoTest }"
      :membership="membership"
    />
    <!-- 
      权益相关 
      memberBox：新客有圆角 老客无圆角、无背景色（取父组件背景色）
      benefitList：新客菜卡颜色灰色  老客菜卡颜色白色
    -->
    <memberBox>
      <!-- 权益大卡-权益平铺 -->
      <div>
        <template v-if="isEasyInfoTest">
          <div v-if="isNewUserStatus" class="v2_test_pt32"></div>
        </template>
        <template v-else>
          <memberTitle :title="$t('FoodC_update_LeTO_aqit' /**会员权益 */)" />
        </template>
        <benefitList :benefitInfo="benefitInfo" :benefitList="benefitInfo.content" />
      </div>
      <!-- 管理入口 -->
      <template v-if="!isNewUserStatus">
        <memberTitle :title="$t('FoodC_update_QQlM_iHYO' /**设置 */)" />
        <manageEntry :class="{ v2_test_margin: isEasyInfoTest }" :membership="membership" />
      </template>
      <!-- 预计可省 -->
      <template v-if="isNewUserStatus">
        <savingInfo :saleInfo="saleInfo" class="saving_info_style" />
      </template>
    </memberBox>

    <!-- 底部已订阅文案条 - 会员老客-已开通&已订阅展示  -->
    <subscribeText v-if="isShowSubscribeText" :membership="membership" />

    <!-- 新客 && 跨国会员管理入口 -->
    <CancelEntry v-if="isNewUserStatus && hasTransNationalInfo" />
    <div :style="{ paddingTop: '160px' }"></div>
    <!-- footer -->
    <memberFooter :headInfo="headInfo" />

    <!-- 升级成功提示框 -->
    <member-success-dialog
      v-model="isShowSuccessDialog"
      :dialogData="successDialogData"
      :type="dialogType"
      :source="dialogSource"
    />
  </div>
</template>

<script>
import memberBanner from '@/page/member/components-v2/member-banner.vue'
import memberTitle from '@/page/member/components-v2/member-title.vue'
import memberBox from '@/page/member/components-v2/member-box.vue'
import memberCard from '@/page/member/components-v2/member-card.vue'
import memberCardV2 from '@/page/member/components-v2/member-card-v2.vue'
import benefitList from '@/page/member/components-v2/benefit/benefit-list.vue'
import pauseStatusBar from '@/page/member/components-v2/pause-status-bar.vue'
import savingInfo from '@/page/member/components-v2/saving-info.vue'
import manageEntry from '@/page/member/components-v2/manage-entry.vue'
import subscribeText from '@/page/member/components-v2/subscribe-text.vue'
import memberFooter from '@/page/member/components-v2/member-footer.vue'
import upgradeLongTerm from '@/page/member/components-v2/upgrade-long-term.vue'
import longTermBar from '@/page/member/components-v2/long-term-bar.vue'
import MemberSuccessDialog from '@/page/member/components-v2/member-success-dialog.vue'
import CancelEntry from '@/page/member/components-v2/no-open-city/cancel-entry.vue'
import { MEMBER_STATUS, SUCCESS_TYPE } from '@/page/member/common/enumsUtil.js'
import mixin from '@/page/member/mixins.js'

export default {
  name: 'MemberEntryV2',
  components: {
    memberCard,
    benefitList,
    pauseStatusBar,
    savingInfo,
    manageEntry,
    subscribeText,
    memberFooter,
    memberBanner,
    memberBox,
    memberTitle,
    upgradeLongTerm,
    longTermBar,
    MemberSuccessDialog,
    memberCardV2,
    CancelEntry,
  },
  mixins: [mixin],
  props: {
    pageInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShowSuccessDialog: false,
      successDialogData: {},
      SUCCESS_TYPE,

      dialogSource: '', // 弹窗上层来源
      dialogType: 0,
    }
  },
  computed: {
    membership() {
      return this.pageInfo?.membership || {}
    },
    headInfo() {
      return this.pageInfo?.headInfo || {}
    },
    benefitInfo() {
      return this.pageInfo?.benefitInfo || {}
    },
    saleInfo() {
      return this.pageInfo?.saleInfo || {}
    },
    // 背景样式
    bgStyle() {
      const banner = this.headInfo?.atmosphereImageUrl
      let backgroundColor = ''

      if (this.memberStatus !== MEMBER_STATUS.newNoBuy) {
        backgroundColor = '#f5f5f7'
      }

      return {
        backgroundImage: `url(${banner})`,
        backgroundColor,
      }
    },
    // 实验样式
    bgClass() {
      // 老客、tab页、命中精简实验
      if (!this.isNewUserStatus && this.isFromTab && this.isEasyInfoTest) {
        return 'v2_test_banner'
      }
      return ''
    },
  },
  created() {},
  methods: {
    // 长周期升级弹窗回调
    handleSuccessUpgradeDialog(data) {
      this.isShowSuccessDialog = true
      this.successDialogData = data
      this.dialogType = SUCCESS_TYPE.upgrade
      this.dialogSource = '' // todo 原逻辑传入 member
    },
    // 免费送N个月弹窗回调（入口层调用）
    handleSuccessFreeGiveDialog(data) {
      this.isShowSuccessDialog = true
      this.successDialogData = data
      this.dialogType = SUCCESS_TYPE.freeGive
      this.dialogSource = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.member_v2_wrap {
  width: 100%;
  height: 100%;
  background-color: #fff;
  &.bg_banner {
    background-size: 100%;
    background-repeat: no-repeat;
    &.v2_test_banner {
      background-size: 100% 380px;
    }
  }
}
.saving_info_style {
  padding-top: 48px;
  padding-bottom: 60px;
}

/** @desc 实验样式 */
.v2_test_pt32 {
  padding-top: 32px;
}
.v2_test_margin {
  margin-left: 32px !important;
  margin-right: 32px !important;
}
</style>
